export default function darkClass(name,theme){
    return theme==='dark'?name+'-dark '+name:name;
} 